//WidgetHeading.tsx =================================================
import "../Util/Prototypes";

import * as Default from "../Default";
import * as ExpandOnPhone from "./ExpandOnPhone";

import { Icon, IconButton, Typography } from "@mui/material";

import React from "react";

//Render function.
interface iProps {
   title: string;
   onClose(): void;
}

export function Render(props: iProps) {
   //Set refresh method.
   const [ignored, refresh] = React.useReducer((x: number) => x + 1, 0);

   //Component did mount.
   React.useEffect(() => {
   }, []);

   // Make onClose a bound function
   function handleClose() {
      props.onClose();
   }

   //Render components.
   return (
      <div style={Default.styles.appToolHeading}>
         <Typography variant="body1" style={{ marginLeft: 12 }}>
            {props.title}
         </Typography>

         <ExpandOnPhone.Render />

         <IconButton size="medium" color="default" onClick={handleClose} title="Close" aria-label="Close">
            <Icon color="action">close</Icon>
         </IconButton>
      </div>
   ); //end return.

} //end function.
